import { apiService } from "api/apiService";
import type {
  StudentPortfolioActivityResource,
  PortfolioFilteredStatisticsResource,
  FilterResource,
} from "api/generated";
import {
  portfolioActivityFromDto,
  studentProfileStatisticsFromDto,
} from "portfolio/api/mappers";
import { mapFilters } from "shared/mappers";
import type {
  StudentActivity,
  StudentProfileStatistics,
} from "portfolio/types";
import type { ActivityFilter } from "portfolio/types";

export const fetchTeacherStudentActivities = async (
  studentId: string,
  filters: Record<string, string> = {},
): Promise<StudentActivity[]> => {
  const {
    data: { data },
  } = await apiService.get<{ data: StudentPortfolioActivityResource[] }>(
    `api/portfolio/students/${studentId}/activities`,
    {
      params: {
        ...(Object.keys(filters).length && filters),
      },
    },
  );

  return data.map(portfolioActivityFromDto);
};

export const fetchTeacherStudentStatistics = async (
  studentId: string,
): Promise<StudentProfileStatistics> => {
  const {
    data: { data: statistics },
  } = await apiService.get<{ data: PortfolioFilteredStatisticsResource }>(
    `api/portfolio/students/${studentId}/statistics`,
  );

  return studentProfileStatisticsFromDto(statistics);
};

export const fetchTeacherStudentActivityFilters = async (
  studentId: string,
): Promise<ActivityFilter[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    `api/portfolio/students/${studentId}/activities/filters`,
  );

  return mapFilters(filters) as ActivityFilter[];
};

export const fetchTeacherStudentChart = async (
  studentId: string,
): Promise<unknown[]> => {
  const { data } = await apiService.get(
    `api/portfolio/students/${studentId}/chart`,
  );

  return data;
};
